import { render, staticRenderFns } from "./VacationSettings.vue?vue&type=template&id=1797d7e9"
import script from "./VacationSettings.vue?vue&type=script&lang=js"
export * from "./VacationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports